import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, OnDestroy, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, Subscription } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { AuthService } from 'src/app/core/auth/auth.service';
import { SnackbarService } from 'ok-angular-shared/components';

@Injectable()
export class ErrorHandlerService implements ErrorHandler, OnDestroy {
  private snackBar = inject(MatSnackBar);
  private readonly zone = inject<NgZone>(NgZone);
  private appState = inject(AppState);
  private authService = inject(AuthService);
  private snackbarService = inject(SnackbarService);

  private errors: Subject<any> = new Subject();
  private subscriptions: Array<Subscription> = [];

  constructor() {
    this.subscriptions.push(
      this.errors.subscribe(async err => {
        const error = err.rejection || err.originalError || err; // find the real error message if wrapped from promise
        if (error.status && error.status === 401) {
          // user is not authenticated anymore
          console.error(error);
          console.error(location.href);
          this.authService.login(location.href);

          //isInErrorState is alway set to false in interceptor
          this.appState.isInErrorState$.next(true);
        } else if (error.status && error.status === 403) {
          // user is not authenticated anymore
          console.error(error);
          if (error.error) {
            this.zone.run(() => {
              this.snackbarService.error(`${error.error.message} (${error.error.code})`);
            });
          } else {
            this.snackbarService.error(`${error.message}`);
          }
          //isInErrorState is alway set to false in interceptor
          this.appState.isInErrorState$.next(true);
        } else if (error.status && error.status === 404) {
          // endpoint responded with 404
          console.error(error);
          this.zone.run(() => {
            this.snackbarService.error(`${error.error.message} (${error.error.code})`);
          });
          //isInErrorState is alway set to false in interceptor
          this.appState.isInErrorState$.next(true);
        } else if (error instanceof HttpErrorResponse) {
          // endpoint responded with error
          console.error(error);
          this.zone.run(() => {
            this.snackbarService.error(`${error.error.message} (${error.error.code})`);
          });
          //isInErrorState is alway set to false in interceptor
          this.appState.isInErrorState$.next(true);
        } else {
          console.error(error);
          console.error(location.href);

          // no status == app error, status == api error
          const errorKey = error.status || '[N/A]';
          const errorMessageTechnical: string = error?.message;
          this.zone.run(() => {
            const snackBarRef = this.snackbarService.error('Der opstod en ukendt fejl');

            // //TODO: Vis modal med mere info ala nedenstÃ¥ende -
            // vil krÃ¦ve at snack message service udvides med en knap:
            // snackBarRef.onAction().subscribe(() => {
            //   this.dialog
            //     .open(GenericModalComponent, {
            //       data: {
            //         header: 'Der er sket en fejl',
            //         text: `${errorKey} - ${errorMessageTechnical}`
            //       },
            //       disableClose: true,
            //     });
            // });
          });
        }
      })
    );
  }
  handleError(error: any) {
    if (error.url && error.url.includes('assets/')) {
      return;
    }

    this.errors.next(error);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }
}
